import helpers from '../../utils/helpers';
import cyclicFramesService from '../hid/cyclicFramesService';
import IqosCommunicatorClient from './iqosCommunicatorClient';

const processFrames = (props) => {
    writeFrameAndPublishResponse(props);
};

const writeFrameAndPublishResponse = ({
    frames,
    onSuccess,
    onError,
    timeout,
    processImmediately,
    processFirst,
    skipErrorOnTimeout,
    isDebug = true,
    responseTimeoutMs,
    retryCount,
    doNotSplit,
}) => {
    addFramesToQueue({
        frames,
        processImmediately,
        processFirst,
        timeout,
        onSuccess: (responses) => {
            helpers.runFunction(onSuccess, responses);
        },
        onError,
        skipErrorOnTimeout,
        isDebug,
        responseTimeoutMs,
        retryCount,
        doNotSplit,
    });
};

const createNew = () => {
    new IqosCommunicatorClient(true);
    cyclicFramesService.resetCyclicFrames();
};

const processQueue = () => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.processQueue();
};

const disable = () => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.disable();
    cyclicFramesService.resetCyclicFrames();
};

const restart = () => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.restartListeners();
};

const addFramesToQueue = (props) => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.addFramesToQueue(props);
};

const clear = () => {
    const iqosCommunicatorClient = new IqosCommunicatorClient();

    iqosCommunicatorClient.clearResponseTimeout();
    iqosCommunicatorClient.clearQueue();
};

export default {
    clear,
    createNew,
    disable,
    processFrames,
    processQueue,
    restart,
    writeFrameAndPublishResponse,
    addFramesToQueue,
};
